const theme = {
  color: {
    primary: "#1982C4", //light blue
    accent1: "#8AC926", //lime green
    accent2: "#ee5b2c", //orange
    accent3: "#a23b72", //purple
    primaryLight: "#58b1e9", //light-blue
    white: "#fff",
    offWhite: "#f7f9f9",
    lightGray1: "#f1f1f1",
    lightGray2: "#ebebeb",
    grayDark1: "#757575",
    grayDark2: "#333333"
  },
  text: {
    display: "'Oswald', sans-serif",
  },
  fontSize: {
    xsmall: "1.8rem",
    small: "2.2rem",
    medium: "2.7rem",
    large: "4rem",
    xlarge: "7rem",
  },
}


export default theme
